import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import FastDebtConsolidationWrapper from "@components/layouts/fastDebtConsolidationWrapper";
import { useDomainContext } from "@hooks/useDomainContext";

export default function DebtReliefAnalysisHome(): ReactElement {
    const { domain } = useDomainContext();
    return (
        <FastDebtConsolidationWrapper>
            <TermsAndConditions
                category={domain?.categories[0]?.name}
                domain={domain.niceName}
            />
        </FastDebtConsolidationWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
